webpackJsonp([70144966829960],{

/***/ 295:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formSubmissionHandler = __webpack_require__(146);
	
	__webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_React$Component) {
	  _inherits(Contact, _React$Component);
	
	  function Contact() {
	    _classCallCheck(this, Contact);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  Contact.prototype.componentDidMount = function componentDidMount() {
	    (0, _formSubmissionHandler.loaded)();
	  };
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      "section",
	      { className: "contact page-content", id: "contact" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "custom-card", style: { marginTop: 0 } },
	              _react2.default.createElement(
	                "form",
	                {
	                  id: "gform",
	                  method: "POST",
	                  className: "pure-form pure-form-stacked",
	                  "data-email": "example@email.com",
	                  action: "https://script.google.com/macros/s/AKfycbzj5-AclCiNmQKP_BwK0y0_6UsWBEeDknpBpzQAh2JFOA196p1e/exec"
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement("input", {
	                    className: "form-control",
	                    id: "name",
	                    name: "Name",
	                    type: "text",
	                    placeholder: "Name",
	                    required: true
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement("input", {
	                    className: "form-control",
	                    id: "email",
	                    name: "Email",
	                    type: "email",
	                    placeholder: "Email Address",
	                    required: true
	                  })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { id: "email-invalid", style: { display: "none" } },
	                  "Must be a valid email address"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement("textarea", {
	                    className: "form-control",
	                    id: "message",
	                    name: "Message",
	                    type: "text",
	                    placeholder: "Your Message...",
	                    required: true
	                  })
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { className: "btn btn-primary" },
	                  "Send"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { display: "none" }, id: "thankyou_message" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Thanks for contacting us! We will get back to you soon!"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "h4",
	              { className: "title" },
	              "We're happy to hear from you!"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "We'll do our best to respond in 2-3 business days from the time you send your message. We appreciate your feedback and welcome any questions."
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nav = __webpack_require__(29);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _breadcrumb = __webpack_require__(15);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _contact = __webpack_require__(135);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage(props) {
	  return _react2.default.createElement(
	    "main",
	    null,
	    _react2.default.createElement(_nav2.default, null),
	    _react2.default.createElement(_breadcrumb2.default, { title: "Contact" }),
	    _react2.default.createElement(
	      "div",
	      { className: "col-12 text-center menu-footer", style: { margin: 20 } },
	      "All form submissions are stored automatically on a Google Sheet",
	      " ",
	      _react2.default.createElement(
	        "a",
	        {
	          target: "_blank",
	          href: "https://docs.google.com/spreadsheets/d/1VsmA57lXm2_VslfSFViYOTxSiwIKNB09SwKRESHu6AI/edit?usp=sharing"
	        },
	        "here"
	      ),
	      ", then an email is sent to a specific email address detailing the message."
	    ),
	    _react2.default.createElement(_contact2.default, null)
	  );
	};
	
	exports.default = ContactPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function validEmail(email) {
	  // see:
	  var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	  return re.test(email);
	}
	
	function validateHuman(honeypot) {
	  if (honeypot) {
	    //if hidden form filled up
	    console.log("Robot Detected!");
	    return true;
	  } else {
	    console.log("Welcome Human!");
	  }
	}
	
	// get all data in form and return object
	function getFormData() {
	  var form = document.getElementById("gform");
	  var elements = form.elements; // all form elements
	  var fields = Object.keys(elements).map(function (k) {
	    if (elements[k].name !== undefined) {
	      return elements[k].name;
	      // special case for Edge's html collection
	    } else if (elements[k].length > 0) {
	      return elements[k].item(0).name;
	    }
	  }).filter(function (item, pos, self) {
	    return self.indexOf(item) == pos && item;
	  });
	  var data = {};
	  fields.forEach(function (k) {
	    data[k] = elements[k].value;
	    var str = ""; // declare empty string outside of loop to allow
	    // it to be appended to for each item in the loop
	    if (elements[k].type === "checkbox") {
	      // special case for Edge's html collection
	      str = str + elements[k].checked + ", "; // take the string and append
	      // the current checked value to
	      // the end of it, along with
	      // a comma and a space
	      data[k] = str.slice(0, -2); // remove the last comma and space
	      // from the  string to make the output
	      // prettier in the spreadsheet
	    } else if (elements[k].length) {
	      for (var i = 0; i < elements[k].length; i++) {
	        if (elements[k].item(i).checked) {
	          str = str + elements[k].item(i).value + ", "; // same as above
	          data[k] = str.slice(0, -2);
	        }
	      }
	    }
	  });
	
	  // add form-specific values into the data
	  data.formDataNameOrder = JSON.stringify(fields);
	  data.formGoogleSheetName = form.dataset.sheet || "Contact Form Responses"; // default sheet name
	  data.formGoogleSendEmail = form.dataset.email || ""; // no email by default
	
	  console.log(data);
	  return data;
	}
	
	function handleFormSubmit(event) {
	  // handles form submit withtout any jquery
	  event.preventDefault(); // we are submitting via xhr below
	  var data = getFormData(); // get the values submitted in the form
	
	  /* OPTION: Remove this comment to enable SPAM prevention, see README.md
	  if (validateHuman(data.honeypot)) {  //if form is filled, form will not be submitted
	    return false;
	  }
	  */
	
	  if (!validEmail(data.Email)) {
	    // if email is not valid show error
	    document.getElementById("email-invalid").style.display = "block";
	    return false;
	  } else {
	    var url = event.target.action; //
	    var xhr = new XMLHttpRequest();
	    xhr.open("POST", url);
	    // xhr.withCredentials = true;
	    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
	    xhr.onreadystatechange = function () {
	      console.log(xhr.status, xhr.statusText);
	      console.log(xhr.responseText);
	      document.getElementById("gform").style.display = "none"; // hide form
	      document.getElementById("thankyou_message").style.display = "block";
	      return;
	    };
	    // url encode form data for sending as post data
	    var encoded = Object.keys(data).map(function (k) {
	      return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
	    }).join("&");
	    xhr.send(encoded);
	  }
	}
	// function loaded() {
	//   console.log("contact form submission handler loaded successfully");
	//   // bind to the submit event of our form
	//   var form = document.getElementById("gform");
	//   form.addEventListener("submit", handleFormSubmit, false);
	// }
	
	var loaded = function loaded() {
	  console.log("contact form submission handler loaded successfully");
	  // bind to the submit event of our form
	  var form = document.getElementById("gform");
	  form.addEventListener("submit", handleFormSubmit, false);
	};
	
	exports.loaded = loaded;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-f576c8fcb1056f5aeb46.js